import { Component, input } from '@angular/core';

/**
 * Overlay full-screen (logo pulsando + spinner) usado em fluxos de "criar/duplicar e navegar":
 * cobre a tela toda enquanto uma operação assíncrona roda, antes de navegar para o resultado.
 * Extraído do overlay que já existia embutido em `OrderDetailsComponent` (criação de documento).
 */
@Component({
    selector: 'ra-full-page-loading',
    standalone: true,
    templateUrl: './ra-full-page-loading.component.html',
    styleUrl: './ra-full-page-loading.component.scss',
})
export class RaFullPageLoadingComponent {
    public message = input<string>('');
}
